<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-类别管理-编辑类别
  -->
  <el-dialog title="编辑类别" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <el-form size="small" :model="form" ref="form">
      <div class="common-form">基本信息</div>
      <el-form-item label="类别名称" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: '请输入类别名称'}]">
        <el-input v-model="form.name" placeholder="请输入类别名称"></el-input>
      </el-form-item>
       <el-form-item label="选择角色" :label-width="formLabelWidth">
        <el-select v-model="form.setting.role_id"  placeholder="-请选择角色-" >
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类别排序" :label-width="formLabelWidth" prop="sort" :rules="[{required: true,message: '请输入类别排序'}]">
        <el-input v-model="form.sort" placeholder="请输入类别排序"></el-input>
      </el-form-item>
      <el-form-item label="简介" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.introduce" placeholder="请输入简介" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">入驻费用</div>
      <el-form-item label="入驻费用" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.setting.charge_fee" placeholder="请输入入住费用" class="max-w260"></el-input>
      </el-form-item>
        <el-form-item label="赠送短信" :label-width="formLabelWidth" prop="senddx" >
        <el-input type="number"  v-model="form.setting.senddx" placeholder="请输入赠送短信" class="max-w260"></el-input>
      </el-form-item>
      <!-- <el-form-item label="保证金" :label-width="formLabelWidth" >
        <el-input type="number"  v-model="form.setting.deposit" placeholder="请输入保证金" class="max-w260"></el-input>
      </el-form-item> -->
      <!-- <div class="common-form">更多权限</div>
      <el-form-item label="订单" :label-width="formLabelWidth">
       
          <el-checkbox v-model="form.setting.order_detail">详情</el-checkbox>
          <el-checkbox v-model="form.setting.order_send">发货</el-checkbox>
          <el-checkbox v-model="form.setting.order_aftersale">售后</el-checkbox>
     
      </el-form-item>
       <el-form-item label="产品" :label-width="formLabelWidth">
       
          <el-checkbox v-model="form.setting.product_add_check">添加需要审核</el-checkbox>
          <el-checkbox v-model="form.setting.product_edit_check">修改需要审核</el-checkbox>
          <el-checkbox v-model="form.setting.product_price_edit">价格修改</el-checkbox>
          <el-checkbox v-model="form.setting.product_discount_edit">会员类别价格修改</el-checkbox>
          <el-checkbox v-model="form.setting.product_shelf_edit">上架后可修改</el-checkbox>
          <el-checkbox v-model="form.setting.product_product_op">产品操作</el-checkbox>
          
     
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editGrade" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import SupplyApi from '@/api/supply.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
        roleList:[]
      };
    },
    props: ['open_edit', 'form'],
    created() {
      this.form.setting.order_detail = this.form.setting.order_detail==1?true:false;
      this.form.setting.order_send = this.form.setting.order_send==1?true:false;
      this.form.setting.order_aftersale = this.form.setting.order_aftersale==1?true:false;

      this.form.setting.product_add_check = this.form.setting.product_add_check==1?true:false;
      this.form.setting.product_edit_check = this.form.setting.product_edit_check==1?true:false;
      this.form.setting.product_price_edit = this.form.setting.product_price_edit==1?true:false;
      this.form.setting.product_discount_edit = this.form.setting.product_discount_edit==1?true:false;
      this.form.setting.product_shelf_edit= this.form.setting.product_shelf_edit==1?true:false;
      this.form.setting.product_product_op= this.form.setting.product_product_op==1?true:false;

      
      this.form.setting.role_id = parseInt(this.form.setting.role_id);
      this.dialogVisible = this.open_edit;
       this.getRoleList();
    },
    methods: {
      /*修改用户*/
      editGrade() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
              params.setting.order_detail=params.setting.order_detail==true?1:0;
              params.setting.order_send=params.setting.order_send==true?1:0;
              params.setting.order_aftersale=params.setting.order_aftersale==true?1:0;

              params.setting.product_add_check=params.setting.product_add_check==true?1:0;
              params.setting.product_edit_check=params.setting.product_edit_check==true?1:0;
              params.setting.product_price_edit=params.setting.product_price_edit==true?1:0;
              params.setting.product_discount_edit=params.setting.product_discount_edit==true?1:0;
              params.setting.product_shelf_edit=params.setting.product_shelf_edit==true?1:0;
              params.setting.product_product_op=params.setting.product_product_op==true?1:0;
              
           
            SupplyApi.editGrade(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '恭喜你，类别修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },
       /*获取角色列表*/
      getRoleList() {
         SupplyApi.roleLists('', true)
          .then(res => {
            console.log(res.data.list)
            this.roleList = res.data.list;
          })
          .catch(error => {

          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/grade/Edit.vue